import { FC, useEffect, useState, } from 'react';
import { getStandardTaskSelection } from '@/common/api/expandStore/expansiontask';
import { FormItemProps, SelectProps } from 'antd';
import V2FormSelect from '@/common/components/Form/V2FormSelect/V2FormSelect';

/**
 * @Description 跟进状态
 */
const FormFollowingStatus:FC<{
  name: string;
  label?: string;
  rules?: any;
  placeholder?: string;
  selectConfig?: SelectProps;
  formConfig?: FormItemProps;
  required?: boolean;
  isEdit?: boolean; // 是否新增、编辑状态
  disabled?: boolean;
}> = ({
  name,
  label,
  rules,
  placeholder,
  selectConfig,
  formConfig,
  required,
  disabled,
}) => {

  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    getSelection();
  }, []);

  const getSelection = async () => {
    const options = await getStandardTaskSelection();

    const followingStatusList = options?.followingStatusList.map((item) => ({
      label: item.name,
      value: item.id
    })) || [];
    setOptions(followingStatusList);
  };

  return (
    <V2FormSelect
      disabled={disabled}
      name={name}
      label={label}
      options={options}
      rules={rules}
      required={required}
      placeholder={placeholder}
      config={{
        showSearch: true,
        ...selectConfig,
      }}
      formItemConfig={formConfig}
    />
  );
};

export default FormFollowingStatus;
